/**
 * BOGOS Widget Customizer
 * Customize BOGO offer display to match desired design
 */
(function() {
  'use strict';

  // SVG Gift Icon
  const GIFT_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M20.25 6.74997H16.9613C16.9978 6.71903 17.0353 6.68903 17.0709 6.65622C17.3557 6.40326 17.5851 6.09427 17.745 5.74858C17.9049 5.40289 17.9917 5.02793 18 4.64715C18.0123 4.2306 17.9394 3.81592 17.7856 3.42858C17.6319 3.04124 17.4006 2.68941 17.106 2.39468C16.8113 2.09996 16.4596 1.86857 16.0723 1.71471C15.685 1.56085 15.2703 1.48778 14.8538 1.49997C14.4728 1.50817 14.0977 1.59492 13.7518 1.75479C13.406 1.91465 13.0968 2.14419 12.8438 2.42903C12.4936 2.83487 12.2089 3.29288 12 3.78653C11.7911 3.29288 11.5064 2.83487 11.1562 2.42903C10.9032 2.14419 10.594 1.91465 10.2482 1.75479C9.90232 1.59492 9.52718 1.50817 9.14625 1.49997C8.72969 1.48778 8.31503 1.56085 7.92774 1.71471C7.54044 1.86857 7.18868 2.09996 6.89405 2.39468C6.59941 2.68941 6.36812 3.04124 6.21438 3.42858C6.06064 3.81592 5.98768 4.2306 6 4.64715C6.00833 5.02793 6.09514 5.40289 6.255 5.74858C6.41486 6.09427 6.64434 6.40326 6.92906 6.65622C6.96469 6.68715 7.00219 6.71715 7.03875 6.74997H3.75C3.35218 6.74997 2.97064 6.908 2.68934 7.18931C2.40804 7.47061 2.25 7.85214 2.25 8.24997V11.25C2.25 11.6478 2.40804 12.0293 2.68934 12.3106C2.97064 12.5919 3.35218 12.75 3.75 12.75V18.75C3.75 19.1478 3.90804 19.5293 4.18934 19.8106C4.47064 20.0919 4.85218 20.25 5.25 20.25H18.75C19.1478 20.25 19.5294 20.0919 19.8107 19.8106C20.092 19.5293 20.25 19.1478 20.25 18.75V12.75C20.6478 12.75 21.0294 12.5919 21.3107 12.3106C21.592 12.0293 21.75 11.6478 21.75 11.25V8.24997C21.75 7.85214 21.592 7.47061 21.3107 7.18931C21.0294 6.908 20.6478 6.74997 20.25 6.74997ZM13.9688 3.42278C14.0875 3.29164 14.2321 3.18647 14.3934 3.11387C14.5547 3.04127 14.7293 3.00281 14.9062 3.0009H14.9522C15.1595 3.0022 15.3645 3.04487 15.5552 3.12641C15.7458 3.20795 15.9183 3.32672 16.0624 3.47576C16.2066 3.6248 16.3195 3.80112 16.3947 3.99438C16.4698 4.18763 16.5056 4.39394 16.5 4.60122C16.4981 4.77812 16.4596 4.95272 16.387 5.11405C16.3144 5.27538 16.2093 5.41997 16.0781 5.53872C15.1884 6.32622 13.7119 6.60372 12.7969 6.70122C12.9094 5.7084 13.2188 4.26559 13.9688 3.42278ZM7.96031 3.45653C8.25088 3.16599 8.64441 3.00191 9.05531 2.99997H9.10125C9.27815 3.00187 9.45275 3.04034 9.61409 3.11293C9.77542 3.18553 9.92 3.2907 10.0388 3.42184C10.8253 4.31059 11.1028 5.78434 11.2003 6.69559C10.2891 6.60184 8.81531 6.32059 7.92656 5.53403C7.79543 5.41528 7.69026 5.2707 7.61766 5.10936C7.54506 4.94803 7.5066 4.77343 7.50469 4.59653C7.49887 4.38581 7.53593 4.17611 7.61361 3.98014C7.69128 3.78418 7.80796 3.60604 7.95656 3.45653H7.96031ZM3.75 8.24997H11.25V11.25H3.75V8.24997ZM5.25 12.75H11.25V18.75H5.25V12.75ZM18.75 18.75H12.75V12.75H18.75V18.75ZM20.25 11.25H12.75V8.24997H20.25V11.25Z" fill="#343330"/>
  </svg>`;

  // Config
  const CONFIG = {
    // Show "FREE" label
    showFreeLabel: true,
    freeLabelText: 'FREE',

    // Show gift product name
    showGiftName: true
  };

  /**
   * Mutation relevance helpers — avoid running BOGOS work on unrelated DOM churn.
   */
  function elementMatchesAny(el, selectors) {
    if (!el || el.nodeType !== 1 || typeof el.matches !== 'function') return false;
    for (let i = 0; i < selectors.length; i++) {
      try {
        if (el.matches(selectors[i])) return true;
      } catch (e) {}
    }
    return false;
  }

  function nodeOrDescendantMatches(node, selectors) {
    if (!node || node.nodeType !== 1) return false;
    if (elementMatchesAny(node, selectors)) return true;
    if (typeof node.querySelector !== 'function') return false;
    for (let i = 0; i < selectors.length; i++) {
      try {
        if (node.querySelector(selectors[i])) return true;
      } catch (e) {}
    }
    return false;
  }

  function closestMatches(el, selectors) {
    let current = el && el.nodeType === 1 ? el : el && el.parentElement;
    while (current && current.nodeType === 1) {
      if (elementMatchesAny(current, selectors)) return true;
      current = current.parentElement;
    }
    return false;
  }

  function mutationsTouchSelectors(mutations, selectors) {
    for (let i = 0; i < mutations.length; i++) {
      const mutation = mutations[i];
      if (mutation.type === 'characterData') {
        if (closestMatches(mutation.target, selectors)) return true;
        continue;
      }
      // childList/attributes: parent container may match even when leaf nodes do not
      if (closestMatches(mutation.target, selectors)) return true;
      const added = mutation.addedNodes;
      for (let j = 0; j < added.length; j++) {
        if (nodeOrDescendantMatches(added[j], selectors)) return true;
      }
      const removed = mutation.removedNodes;
      for (let k = 0; k < removed.length; k++) {
        if (nodeOrDescendantMatches(removed[k], selectors)) return true;
      }
    }
    return false;
  }

  const BOGOS_WIDGET_SELECTORS = [
    '.fg-gift-thumbnail-offer',
    '.bogos-gift-thumbnail-view',
    '#sca-gift-thumbnail',
    '[class*="fg-gift"]',
    '[id*="bogos"]',
    '[class*="bogos"]'
  ];

  const PRODUCT_CARD_SELECTORS = [
    '.product-card',
    '.product-card__wrapper',
    '.product-card__image-wrapper',
    '.sca-gift-icon-collection-page',
    '.sca-gift-icon-collection-img',
    '#sca-gift-icon',
    '.sca-gift-icon'
  ];

  const PRODUCT_BADGE_SELECTORS = [
    '.product__badges',
    '.product__block--title',
    '#sca-gift-icon',
    '.sca-gift-icon',
    '.product_infor_title'
  ];

  const CART_SAVINGS_SELECTORS = [
    'cart-drawer',
    '#CartDrawer',
    '.cart-drawer',
    'main-cart',
    '#MainCart',
    '.main-cart',
    '.bogos-progress-count-down-message',
    '.bogos-custom-progress-message',
    '.bogos-progress-bar-container',
    '[data-bogos-cart-savings]',
    '.bogos-integration-page-builder-progressing-bar'
  ];

  const CURRENCY_ROOT_SELECTORS = [
    'cart-drawer',
    '#CartDrawer',
    '.cart-drawer',
    '[id*="bogos"]',
    '[class*="bogos"]',
    '[class*="sca-"]',
    '[class*="fg-"]',
    '.cart',
    '#MainCart',
    '.bogos-progress-bar-container'
  ];

  const BOGOS_RELOCATE_SELECTORS = [
    '[data-bogos-cart-discount-view]',
    '#bogos-cart-discount-view',
    '[data-bogos-cart-discount-mobile-slot]',
    '[data-bogos-cart-discount-home]',
    '.product__block--bogos-cart-discount',
    '.bogos-integration-page-builder-cart-discount'
  ];

  /**
   * Get gift product name from image alt text
   */
  function getGiftNameFromImage(img) {
    const alt = img.getAttribute('alt');
    if (alt) {
      return alt.trim();
    }
    return 'Free Gift';
  }

  /**
   * Customize BOGOS widget
   */
  function customizeBogosWidget() {
    const widgets = document.querySelectorAll('.fg-gift-thumbnail-offer');
    
    if (widgets.length === 0) {
      return false;
    }

    widgets.forEach(widget => {
      // Always cleanup Swym wishlist buttons in BOGO block
      widget
        .querySelectorAll('.swym-wishlist-collections-v2-container, .swym-wishlist-collections-v2')
        .forEach((wishlistNode) => wishlistNode.remove());

      // Mark as customized to avoid re-processing
      if (widget.dataset.customized === 'true') return;
      widget.dataset.customized = 'true';

      // 1. Add gift icon before title
      const titleElement = widget.querySelector('.fg-gift-thumbnail-offer-title');
      if (titleElement && !titleElement.querySelector('.bogos-gift-icon')) {
        const iconSpan = document.createElement('span');
        iconSpan.className = 'bogos-gift-icon';
        iconSpan.innerHTML = GIFT_ICON_SVG;
        titleElement.insertBefore(iconSpan, titleElement.firstChild);
      }

      // 2. Add product name and FREE label to each gift item
      const productItems = widget.querySelectorAll('.product-item');

      productItems.forEach(item => {
        // Skip if already customized
        if (item.querySelector('.bogos-custom-gift-info')) return;

        const link = item.querySelector('.gift-original-url');
        const img = item.querySelector('.fg-gift-image');

        if (link && img) {
          // Create info container
          const infoDiv = document.createElement('div');
          infoDiv.className = 'bogos-custom-gift-info';

          // Add gift product name
          if (CONFIG.showGiftName) {
            const giftName = getGiftNameFromImage(img);
            const nameSpan = document.createElement('span');
            nameSpan.className = 'bogos-custom-gift-name';
            nameSpan.textContent = giftName;
            infoDiv.appendChild(nameSpan);
          }

          // Add FREE label
          if (CONFIG.showFreeLabel) {
            const freeSpan = document.createElement('span');
            freeSpan.className = 'bogos-custom-free-label';
            freeSpan.textContent = CONFIG.freeLabelText;
            infoDiv.appendChild(freeSpan);
          }

          // Append to link (after image)
          link.appendChild(infoDiv);
        }
      });

      console.log('[BOGOS Customizer] Widget customized successfully');
    });

    return widgets.length > 0;
  }

  /**
   * Init with retry logic
   */
  function init() {
    let attempts = 0;
    const maxAttempts = 30;
    const interval = 500;

    function tryCustomize() {
      attempts++;
      const success = customizeBogosWidget();

      if (!success && attempts < maxAttempts) {
        setTimeout(tryCustomize, interval);
      }
    }

    // Start after DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tryCustomize);
    } else {
      // Short delay to wait for BOGOS widget to load
      setTimeout(tryCustomize, 1000);
    }

    // Watch DOM changes for late-loaded widget (gift/thumbnail nodes only)
    const observer = new MutationObserver((mutations) => {
      if (!mutationsTouchSelectors(mutations, BOGOS_WIDGET_SELECTORS)) return;
      clearTimeout(window.bogosCustomizerTimeout);
      window.bogosCustomizerTimeout = setTimeout(customizeBogosWidget, 200);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Chuyển mọi gift icon (sca-gift-icon-collection-*) vào trong .product-card__image-wrapper,
   * chỉ giữ 1 icon/card. Chạy trên mọi trang (collection, search, homepage, drawer, related...).
   */
  function moveCollectionGiftIconIntoImageWrapper() {
    function moveIconIntoWrapper(iconEl, imageWrapper) {
      if (!imageWrapper || iconEl.closest('.product-card__image-wrapper') === imageWrapper) return false;
      if (imageWrapper.querySelector('.sca-gift-icon-collection-img')) {
        iconEl.remove();
        return true;
      }
      imageWrapper.appendChild(iconEl);
      iconEl.dataset.bogosMoved = 'true';
      return true;
    }

    const wrappers = document.querySelectorAll('.sca-gift-icon-collection-page');
    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.bogosMoved === 'true') return;
      const iconEl = wrapper.querySelector('.sca-gift-icon-collection-img');
      const card = wrapper.querySelector('.product-card') || wrapper.nextElementSibling || wrapper.previousElementSibling;
      if (!iconEl || !card || !card.classList.contains('product-card')) return;
      const imageWrapper = card.querySelector('.product-card__image-wrapper');
      if (moveIconIntoWrapper(iconEl, imageWrapper)) wrapper.dataset.bogosMoved = 'true';
    });

    const allIcons = document.querySelectorAll('.sca-gift-icon-collection-img');
    allIcons.forEach(function (iconEl) {
      if (iconEl.dataset.bogosMoved === 'true') return;
      const cardWrapper = iconEl.closest('.product-card__wrapper');
      if (cardWrapper) {
        const imageWrapper = cardWrapper.querySelector('.product-card__image-wrapper');
        moveIconIntoWrapper(iconEl, imageWrapper);
        return;
      }
      const card =
        iconEl.closest('.product-card') ||
        iconEl.previousElementSibling ||
        iconEl.nextElementSibling;
      if (!card || !card.classList.contains('product-card')) return;
      const imageWrapper = card.querySelector('.product-card__image-wrapper');
      moveIconIntoWrapper(iconEl, imageWrapper);
    });

    document.querySelectorAll('.product-card__image-wrapper').forEach(function (imageWrapper) {
      const icons = imageWrapper.querySelectorAll('.sca-gift-icon-collection-img');
      for (let i = 1; i < icons.length; i++) {
        icons[i].remove();
      }
    });

    return true;
  }

  function initCollectionGiftIcon() {
    function run() {
      moveCollectionGiftIconIntoImageWrapper();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    setTimeout(run, 800);
    setTimeout(run, 2000);
    const observer = new MutationObserver(function (mutations) {
      if (!mutationsTouchSelectors(mutations, PRODUCT_CARD_SELECTORS)) return;
      clearTimeout(window.bogosCollectionIconTimeout);
      window.bogosCollectionIconTimeout = setTimeout(run, 300);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /**
   * Trang product: đưa #sca-gift-icon vào hàng badge sản phẩm.
   */
  function moveProductPageGiftIconOutsideTitle() {
    if (!window.location.pathname.includes('/products/')) return;

    const titleBlock = document.querySelector('.product__block--title');
    const productBadgesContainer = document.querySelector('.product__badges');

    const selectors = ['#sca-gift-icon', '.sca-gift-icon', '[id="sca-gift-icon"]'];
    selectors.forEach(function (sel) {
      const el = document.querySelector(sel);
      if (!el) return;

      // Keep hidden until it is placed in the target badge row to avoid flashing
      if (!el.closest('.product__badges')) {
        el.style.opacity = '0';
      }

      if (el.dataset.bogosMovedToBadges === 'true' && el.closest('.product__badges')) {
        el.style.opacity = '1';
        return;
      }

      if (el.closest('.product_infor_title') && titleBlock) {
        titleBlock.appendChild(el);
      }
      if (el.querySelector && el.querySelector('.product_infor_title') && titleBlock) {
        var toMove = [];
        el.querySelectorAll('.product_infor_title').forEach(function (titleEl) {
          var wrapper = titleEl.closest('h1, a');
          if (wrapper && toMove.indexOf(wrapper) === -1) toMove.push(wrapper);
        });
        toMove.reverse().forEach(function (node) {
          titleBlock.insertBefore(node, titleBlock.firstChild);
        });
      }

      if (productBadgesContainer && !el.closest('.product__badges')) {
        productBadgesContainer.appendChild(el);
        el.dataset.bogosMovedToBadges = 'true';
        el.style.opacity = '1';
      }
    });

    // Remove any Swym button accidentally injected on top of Free Gift badge
    if (productBadgesContainer) {
      const swymInBadge = productBadgesContainer.querySelectorAll(
        '#sca-gift-icon .swym-wishlist-collections-v2-container, #sca-gift-icon .swym-wishlist-collections-v2'
      );
      swymInBadge.forEach(function (node) {
        node.remove();
      });
    }
  }

  function initProductPageGiftIconPosition() {
    if (!window.location.pathname.includes('/products/')) return;
    function run() {
      moveProductPageGiftIconOutsideTitle();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    setTimeout(run, 500);
    setTimeout(run, 1500);
    const observer = new MutationObserver(function (mutations) {
      if (!mutationsTouchSelectors(mutations, PRODUCT_BADGE_SELECTORS)) return;
      run();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /**
   * Spend More Save More qualifies on final_line_price (pre-discount).
   * The progress bar defaults to line_price, which Shopify already reduces by
   * the unlocked amount, so a $1,520.95 cart shows as $79.05 short of $100 OFF.
   * Pin the bar to the same field the discount uses, then rerender once.
   */
  function initSpendMoreProgressPrice() {
    const PROGRESS_PRICE_FIELD = 'final_line_price';
    const RERENDER_EVENT = 'bogos:progress-rerender';
    const MAX_ATTEMPTS = 40;
    const ATTEMPT_DELAY = 250;
    let didRerender = false;

    function applyProgressPriceField() {
      window.Shopify = window.Shopify || {};
      window.Shopify.sca_progress_price = PROGRESS_PRICE_FIELD;

      const bogosShopify =
        window.FGSECOMAPP &&
        window.FGSECOMAPP.variables &&
        window.FGSECOMAPP.variables.Shopify;
      if (!bogosShopify) return false;
      bogosShopify.sca_progress_price = PROGRESS_PRICE_FIELD;
      return true;
    }

    function rerenderProgressBar() {
      if (didRerender) return;
      if (!document.querySelector('.bogos-progress-bar-container')) return;
      didRerender = true;
      document.dispatchEvent(new CustomEvent(RERENDER_EVENT));
    }

    applyProgressPriceField();
    document.addEventListener(RERENDER_EVENT, applyProgressPriceField, true);
    document.addEventListener('cart:updated', applyProgressPriceField, true);
    document.addEventListener('cart:opened', applyProgressPriceField, true);

    let attempts = 0;
    const timer = setInterval(function () {
      attempts += 1;
      if (applyProgressPriceField()) rerenderProgressBar();
      if (didRerender || attempts >= MAX_ATTEMPTS) clearInterval(timer);
    }, ATTEMPT_DELAY);
  }

  if (window.location.pathname.includes('/products/')) {
    init();
    initProductPageGiftIconPosition();
  }
  initCollectionGiftIcon();
  initCurrencyDisplayNormalizer();
  initSpendMoreProgressPrice();
  initCartPageProgressBar();
  initCartSavingsMessage();
  initCartDiscountSettleSync();

  /**
   * Root-cause sync: BOGOS applies Spend More Save More after ATC (~1–3s),
   * but the theme drawer/cart HTML is rendered from the pre-discount cart.
   * Poll Shopify cart until discount settles, then re-render sections so
   * Subtotal / Saved badge match the real cart.total_price.
   */
  function initCartDiscountSettleSync() {
    const POLL_INTERVAL_MS = 400;
    const MAX_POLL_MS = 8000;
    const STABLE_POLLS_REQUIRED = 2;
    let watchToken = 0;
    let isRefreshing = false;
    let lastSyncedSignature = null;

    function getCartSignature(cart) {
      if (!cart) return '';
      const codes = (cart.discount_codes || [])
        .map(function (code) {
          return String(code.code) + ':' + String(code.applicable);
        })
        .sort()
        .join(',');
      const apps = (cart.cart_level_discount_applications || [])
        .map(function (app) {
          return (
            String(app.title) + ':' + String(app.total_allocated_amount || 0)
          );
        })
        .sort()
        .join(',');
      return [
        cart.item_count || 0,
        cart.total_price || 0,
        cart.original_total_price || 0,
        cart.total_discount || 0,
        codes,
        apps
      ].join('|');
    }

    function getExpectedSavingsCents(cart) {
      return Math.max(
        0,
        Number(cart.original_total_price || 0) - Number(cart.total_price || 0)
      );
    }

    function uiOutOfSync(cart) {
      const expectedSavings = getExpectedSavingsCents(cart);
      const freeShippingBadge = document.querySelector(
        'cart-drawer .cart-total-price__saved-badge[aria-label="Free Shipping"], main-cart .cart-total-price__saved-badge[aria-label="Free Shipping"]'
      );
      const savedBadge = document.querySelector(
        'cart-drawer .cart-total-price__saved-badge, main-cart .cart-total-price__saved-badge'
      );
      // data-bogos-cart-savings is Spend More Save More only; Saved badge reflects all discounts.
      const shownHasSavings = Boolean(savedBadge && !freeShippingBadge);
      if (expectedSavings > 0 && !shownHasSavings) return true;
      if (expectedSavings === 0 && shownHasSavings) return true;
      if (expectedSavings > 0 && freeShippingBadge) return true;

      return false;
    }

    function fetchCart() {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (
        response
      ) {
        return response.json();
      });
    }

    function refreshCartSections(cart) {
      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );

      const publishUpdate = function (nextCart, sections) {
        nextCart.sections = sections || nextCart.sections || {};
        isRefreshing = true;
        lastSyncedSignature = getCartSignature(nextCart);
        if (window.FoxTheme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            cart: nextCart
          });
        } else {
          document.dispatchEvent(
            new CustomEvent('cart:refresh', { detail: { open: false } })
          );
        }
        setTimeout(function () {
          isRefreshing = false;
        }, 400);
      };

      if (!sectionsToBundle.length) {
        return fetchCart().then(function (nextCart) {
          document.dispatchEvent(
            new CustomEvent('cart:refresh', { detail: { open: false } })
          );
          lastSyncedSignature = getCartSignature(nextCart);
          return nextCart;
        });
      }

      const root = window.Shopify?.routes?.root || '/';
      const sectionsUrl = root + '?sections=' + sectionsToBundle.join(',');

      return Promise.all([
        cart ? Promise.resolve(cart) : fetchCart(),
        fetch(sectionsUrl, { credentials: 'same-origin' }).then(function (
          response
        ) {
          return response.json();
        })
      ]).then(function (results) {
        publishUpdate(results[0], results[1]);
        return results[0];
      });
    }

    function watchForDiscountSettle(seedCart) {
      const token = ++watchToken;
      let stableCount = 0;
      let previousSignature = seedCart ? getCartSignature(seedCart) : null;
      if (seedCart) lastSyncedSignature = previousSignature;

      const startedAt = Date.now();

      function tick() {
        if (token !== watchToken) return Promise.resolve();
        if (Date.now() - startedAt >= MAX_POLL_MS) return Promise.resolve();

        return new Promise(function (resolve) {
          setTimeout(resolve, POLL_INTERVAL_MS);
        })
          .then(function () {
            if (token !== watchToken) return null;
            return fetchCart();
          })
          .then(function (cart) {
            if (!cart || token !== watchToken) return;

            const signature = getCartSignature(cart);
            if (previousSignature && signature === previousSignature) {
              stableCount += 1;
            } else {
              stableCount = 0;
              previousSignature = signature;
            }

            if (uiOutOfSync(cart)) {
              return refreshCartSections(cart).then(function () {
                stableCount = 0;
                previousSignature = getCartSignature(cart);
                return tick();
              });
            }

            if (stableCount >= STABLE_POLLS_REQUIRED) return;
            return tick();
          })
          .catch(function () {
            return tick();
          });
      }

      return tick();
    }

    function onCartMaybeChanged(event) {
      if (isRefreshing) return;
      const seedCart = event?.detail?.cart || null;
      watchForDiscountSettle(seedCart);
    }

    document.addEventListener('cart:updated', onCartMaybeChanged);
    document.addEventListener('product-ajax:added', onCartMaybeChanged);
    document.addEventListener('cart:opened', function () {
      fetchCart()
        .then(function (cart) {
          if (uiOutOfSync(cart)) return refreshCartSections(cart);
          return watchForDiscountSettle(cart);
        })
        .catch(function () {});
    });

    if (typeof window.fetch === 'function' && !window.__bogosDiscountFetchPatched) {
      window.__bogosDiscountFetchPatched = true;
      const originalFetch = window.fetch.bind(window);
      window.fetch = function () {
        const input = arguments[0];
        const url = typeof input === 'string' ? input : input && input.url;
        const result = originalFetch.apply(window, arguments);
        if (url && /\/discount\//i.test(String(url))) {
          Promise.resolve(result)
            .then(function () {
              watchForDiscountSettle(null);
            })
            .catch(function () {});
        }
        return result;
      };
    }
  }

  function initCartPageProgressBar() {
    if (window.location.pathname !== '/cart') return;

    const PROGRESS_MOUNT_SELECTOR = '.bogos-integration-page-builder-progressing-bar';
    const PROGRESS_CONTAINER_SELECTOR = '.bogos-progress-bar-container';
    const PROGRESS_RERENDER_EVENT = 'bogos:progress-rerender';
    const RENDER_RETRY_DELAY = 500;
    const MAX_RENDER_ATTEMPTS = 20;
    let renderAttempts = 0;

    function renderProgressBar() {
      const mount = document.querySelector(PROGRESS_MOUNT_SELECTOR);
      if (!mount || mount.querySelector(PROGRESS_CONTAINER_SELECTOR)) return;

      document.dispatchEvent(new CustomEvent(PROGRESS_RERENDER_EVENT));
      renderAttempts += 1;
      if (renderAttempts < MAX_RENDER_ATTEMPTS) {
        window.bogosCartPageProgressTimeout = setTimeout(
          renderProgressBar,
          RENDER_RETRY_DELAY
        );
      }
    }

    function scheduleProgressBarRender() {
      clearTimeout(window.bogosCartPageProgressTimeout);
      renderAttempts = 0;
      renderProgressBar();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleProgressBarRender);
    } else {
      scheduleProgressBarRender();
    }

    document.addEventListener('cart:updated', scheduleProgressBarRender);
  }

  function initCartSavingsMessage() {
    const SAVINGS_PREFIX_PATTERN = /^You saved [^,]+(?:,|\s-\s)\s*/;
    const MONEY_PATTERN = /(\$[\d,.]+(?:\s+OFF)?)/g;
    const CIRCULAR_ADD_MORE_PATTERN =
      /^Add\s+\$[\d,.]+\s+more\s+for\s+(\$[\d,.]+)\s+OFF$/i;
    const REWARD_COLOR = '#31B131';
    const CART_SAVINGS_UPDATE_DELAY = 200;
    // Must match Spend More Save More tiers (pre-discount cart value).
    const SPEND_MORE_OFF_TIERS = [
      { minCents: 90000, offCents: 5000, label: '$50 OFF' },
      { minCents: 150000, offCents: 10000, label: '$100 OFF' },
      { minCents: 250000, offCents: 20000, label: '$200 OFF' },
      { minCents: 400000, offCents: 30000, label: '$300 OFF' }
    ];

    function parseMoneyToCents(value) {
      if (!value) return 0;
      const normalized = String(value).replace(/[^0-9.]/g, '');
      if (!normalized) return 0;
      return Math.round(parseFloat(normalized) * 100);
    }

    function formatCentsAsMoney(cents) {
      const absoluteCents = Math.max(0, Math.round(cents));
      const dollars = absoluteCents / 100;
      if (Number.isInteger(dollars)) {
        return '$' + dollars.toLocaleString('en-AU');
      }
      return (
        '$' +
        dollars.toLocaleString('en-AU', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      );
    }

    /**
     * BOGOS progress uses post-discount cart total, so after unlocking $100 OFF
     * it can say "Add $X more for $100 OFF". Rebuild that countdown from the
     * pre-discount total (original_total_price) when the targeted OFF is
     * already covered by real cart savings.
     */
    function resolveProgressMessage(progressMessage, savingsAmount, originalCents) {
      const match = progressMessage.match(CIRCULAR_ADD_MORE_PATTERN);
      if (!match || !savingsAmount || !originalCents) return progressMessage;

      const targetOffCents = parseMoneyToCents(match[1]);
      const savedCents = parseMoneyToCents(savingsAmount);
      if (savedCents < targetOffCents) return progressMessage;

      const nextTier = SPEND_MORE_OFF_TIERS.find(function (tier) {
        return originalCents < tier.minCents;
      });
      if (!nextTier) return '';

      const leftCents = nextTier.minCents - originalCents;
      return (
        'Add ' +
        formatCentsAsMoney(leftCents) +
        ' more for ' +
        nextTier.label
      );
    }

    function getDisplayMessage(sourceMessage) {
      let displayMessage = sourceMessage.parentElement.querySelector(
        '.bogos-custom-progress-message'
      );
      if (displayMessage) return displayMessage;

      displayMessage = document.createElement('div');
      displayMessage.className = 'bogos-custom-progress-message';
      sourceMessage.insertAdjacentElement('afterend', displayMessage);
      return displayMessage;
    }

    function appendStyledProgressMessage(message, progressMessage) {
      progressMessage.split(MONEY_PATTERN).forEach(function (part) {
        if (!part) return;

        if (part.startsWith('$')) {
          const amount = document.createElement('strong');
          amount.textContent = part;
          if (part.endsWith(' OFF')) {
            amount.style.color = REWARD_COLOR;
          }
          message.appendChild(amount);
          return;
        }

        message.appendChild(document.createTextNode(part));
      });
    }

    // Only show "You saved $X" when Shopify cart actually has that discount.
    // Never invent savings from the BOGOS progress tier ladder — that caused
    // progress to claim $50 off while Subtotal still showed the full price.
    function updateCartSavingsMessage() {
      document.querySelectorAll('cart-drawer, main-cart').forEach(function (cartRoot) {
        const sourceMessage = cartRoot.querySelector('.bogos-progress-count-down-message');
        if (!sourceMessage) return;
        sourceMessage.hidden = true;
        sourceMessage.style.setProperty('display', 'none', 'important');

        const savingsSource = cartRoot.querySelector('[data-bogos-cart-savings]');
        const savingsAmount = savingsSource?.dataset.bogosCartSavings || null;
        const originalCents = Number(
          savingsSource?.dataset.bogosCartOriginalCents || 0
        );
        // BOGOS prints the amount twice: a screen-reader span plus the visible
        // value. textContent keeps both, so the custom line shows $37.35$37.35.
        const messageRoot = sourceMessage.cloneNode(true);
        messageRoot.querySelectorAll('.bogos-sr-only').forEach(function (node) {
          node.remove();
        });
        let progressMessage = messageRoot.textContent
          .trim()
          .replace(SAVINGS_PREFIX_PATTERN, '')
          .replace(/A\$/g, '$')
          .replace(/\s*AUD\b/g, '')
          .replace(/(\$[\d,]+(?:\.\d+)?)(?:\1)+/g, '$1')
          .replace(/^(Add\s+\$[\d,.]+)(\s+for\s+)/, '$1 more$2');
        progressMessage = resolveProgressMessage(
          progressMessage,
          savingsAmount,
          originalCents
        );
        const nextMessage = savingsAmount
          ? progressMessage
            ? `You saved ${savingsAmount} - ${progressMessage}`
            : `You saved ${savingsAmount}`
          : progressMessage;
        const displayMessage = getDisplayMessage(sourceMessage);

        if (
          displayMessage.dataset.cartSavingsStyled === nextMessage &&
          displayMessage.textContent.trim() === nextMessage
        ) {
          return;
        }

        displayMessage.replaceChildren();
        if (savingsAmount) {
          displayMessage.appendChild(document.createTextNode('You saved '));
          const savings = document.createElement('strong');
          savings.textContent = savingsAmount;
          displayMessage.appendChild(savings);
          if (progressMessage) {
            displayMessage.appendChild(document.createTextNode(' - '));
          }
        }
        if (progressMessage) {
          appendStyledProgressMessage(displayMessage, progressMessage);
        }
        displayMessage.dataset.cartSavingsStyled = nextMessage;
      });
    }

    function scheduleUpdate() {
      clearTimeout(window.bogosCartSavingsTimeout);
      window.bogosCartSavingsTimeout = setTimeout(
        updateCartSavingsMessage,
        CART_SAVINGS_UPDATE_DELAY
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleUpdate);
    } else {
      scheduleUpdate();
    }

    document.addEventListener('cart:updated', scheduleUpdate);
    document.addEventListener('cart:opened', scheduleUpdate);

    const observer = new MutationObserver(function (mutations) {
      if (!mutationsTouchSelectors(mutations, CART_SAVINGS_SELECTORS)) return;
      scheduleUpdate();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /**
   * Normalize price display: A$520.00 / $980.00 AUD → $520.00 / $980.00
   * Targets cart drawer and BOGOS widgets (app-rendered A$ / AUD).
   * Also strips trailing .00 from BOGOS progress bar milestone prices (Buy $500.00 → Buy $500).
   */
  function initCurrencyDisplayNormalizer() {
    const ROOT_SELECTORS = [
      'cart-drawer',
      '#CartDrawer',
      '.cart-drawer',
      '[id*="bogos"]',
      '[class*="bogos"]',
      '[class*="sca-"]',
      '[class*="fg-"]',
      '.cart',
      '#MainCart',
    ].join(',');
    const PROGRESS_BAR_SELECTOR = '.bogos-progress-bar-container';
    const CURRENCY_TEXT_RE = /A\$|\bAUD\b/;
    const WHOLE_DOLLAR_RE = /(\$[\d,]+)\.00\b/g;

    function normalizeCurrencyString(value) {
      if (!value || !CURRENCY_TEXT_RE.test(value)) return value;
      return value.replace(/A\$/g, '$').replace(/\s*AUD\b/g, '');
    }

    function stripProgressBarTrailingZeros(value) {
      if (!value || value.indexOf('.00') === -1) return value;
      return value.replace(WHOLE_DOLLAR_RE, '$1');
    }

    function normalizeTextNodes(root, transform) {
      if (!root || root.nodeType !== Node.ELEMENT_NODE) return;

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
      }

      textNodes.forEach(function (node) {
        const next = transform(node.nodeValue);
        if (next !== node.nodeValue) {
          node.nodeValue = next;
        }
      });
    }

    function run() {
      document.querySelectorAll(ROOT_SELECTORS).forEach(function (root) {
        normalizeTextNodes(root, normalizeCurrencyString);
      });
      document.querySelectorAll(PROGRESS_BAR_SELECTOR).forEach(function (root) {
        normalizeTextNodes(root, stripProgressBarTrailingZeros);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    let scheduled = null;
    const observer = new MutationObserver(function (mutations) {
      if (!mutationsTouchSelectors(mutations, CURRENCY_ROOT_SELECTORS)) return;
      clearTimeout(scheduled);
      scheduled = setTimeout(run, 100);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /**
   * On mobile, move Spend more Save more below Curated Sets.
   * Desktop keeps the widget in the product info column.
   */
  function relocateBogosCartDiscount() {
    const view = document.querySelector('[data-bogos-cart-discount-view], #bogos-cart-discount-view');
    const mobileSlot = document.querySelector('[data-bogos-cart-discount-mobile-slot]');
    if (!view || !mobileSlot) return;

    const block = view.closest('.product__block--bogos-cart-discount') || view;
    if (!block.parentNode) return;

    let home = document.querySelector('[data-bogos-cart-discount-home]');
    // Home marker must stay outside the moved block so desktop can restore position.
    if (home && block.contains(home)) {
      home.remove();
      home = null;
    }
    if (!home) {
      home = document.createElement('div');
      home.setAttribute('data-bogos-cart-discount-home', '');
      home.hidden = true;
      block.parentNode.insertBefore(home, block);
    }

    const isMobile = window.matchMedia('(max-width: 1023.98px)').matches;
    if (isMobile) {
      if (block.parentNode !== mobileSlot) {
        mobileSlot.appendChild(block);
      }
      return;
    }

    if (home.parentNode && block.parentNode !== home.parentNode) {
      home.parentNode.insertBefore(block, home.nextSibling);
    }
  }

  function initBogosCartDiscountRelocation() {
    relocateBogosCartDiscount();

    const mediaQuery = window.matchMedia('(max-width: 1023.98px)');
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', relocateBogosCartDiscount);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(relocateBogosCartDiscount);
    }

    let relocateScheduled = null;
    const relocateObserver = new MutationObserver(function (mutations) {
      if (!mutationsTouchSelectors(mutations, BOGOS_RELOCATE_SELECTORS)) return;
      clearTimeout(relocateScheduled);
      relocateScheduled = setTimeout(relocateBogosCartDiscount, 100);
    });
    relocateObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBogosCartDiscountRelocation);
  } else {
    initBogosCartDiscountRelocation();
  }
})();
